import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import EmpresaService from 'services/EmpresaService';

export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
	redirect: '',
	token: localStorage.getItem(AUTH_TOKEN) || null
}

export const get = createAsyncThunk('empresa/get',async () => {
    const response = await EmpresaService.get()
    return response;
})

export const getPlanos = createAsyncThunk('empresa/getPlano',async () => {
    const response = await EmpresaService.getPlano()
    return response;
})

export const getModulos = createAsyncThunk('empresa/getModulos',async () => {
    const response = await EmpresaService.getModulos()
    return response;
})

export const atualizarModulos = createAsyncThunk('empresa/atualizarModulos',async (data, { rejectWithValue }) => {
	try {
		const response = await EmpresaService.atualizarModulos(data)
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao salvar instalador')
	}
})

export const atualizarPlano = createAsyncThunk('empresa/atualizarPlano',async (data, { rejectWithValue }) => {
	try {
		const response = await EmpresaService.atualizarPlano(data)
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao salvar instalador')
	}
})

export const salvarConfiguracao = createAsyncThunk('empresa/salvarConfiguracao', async (data, { rejectWithValue }) => {
	try {
		const response = await EmpresaService.salvarConfiguracao(data)
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao salvar configuração')
	}
})

export const salvarTimezone = createAsyncThunk('empresa/salvarTimezone', async (data, { rejectWithValue }) => {
	try {
		const response = await EmpresaService.salvarTimezone(data)
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao salvar timezone')
	}
})

export const salvarGateway = createAsyncThunk('empresa/salvarGateway', async (data, { rejectWithValue }) => {
	try {
		const response = await EmpresaService.salvarGateway(data)
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao salvar gateway')
	}
})

export const salvarGatewayCora = createAsyncThunk('empresa/salvarGatewayCora', async (data, { rejectWithValue }) => {
	try {
		const response = await EmpresaService.salvarGatewayCora(data)
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao salvar gateway Cora')
	}
})

export const empresaSlice = createSlice({
	name: 'empresa',
	initialState,
	reducers: {
		
	},
    extraReducers: (builder) => {
		builder
			.addCase(get.pending, (state) => {
				state.loading = true
			})
			.addCase(get.fulfilled, (state, action) => {
				state.loading = false
				state.empresa = action.payload
			})
			.addCase(get.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(getPlanos.pending, (state) => {
				state.loadingPlano = true
			})
			.addCase(getPlanos.fulfilled, (state, action) => {
				state.loadingPlano = false
				state.planos = action.payload
			})
			.addCase(getPlanos.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loadingPlano = false
			})
			.addCase(getModulos.pending, (state) => {
				state.loadingModulos = true
			})
			.addCase(getModulos.fulfilled, (state, action) => {
				state.loadingModulos = false
				state.modulos = action.payload
			})
			.addCase(getModulos.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loadingModulos = false
			})
			.addCase(atualizarModulos.pending, (state) => {
				state.loadingModulos = true
			})
			.addCase(atualizarModulos.fulfilled, (state, action) => {
				state.loadingModulos = false
			})
			.addCase(atualizarModulos.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loadingModulos = false
			})
			.addCase(atualizarPlano.pending, (state) => {
				state.loadingPlano = true
			})
			.addCase(atualizarPlano.fulfilled, (state, action) => {
				state.loadingPlano = false
			})
			.addCase(atualizarPlano.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loadingPlano = false
			})
			.addCase(salvarConfiguracao.pending, (state) => {
				state.loadingConfiguracao = true
			})
			.addCase(salvarConfiguracao.fulfilled, (state) => {
				state.loadingConfiguracao = false
			})
			.addCase(salvarConfiguracao.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loadingConfiguracao = false
			})
	},
})

export const {
	showLoading,
} = empresaSlice.actions

export default empresaSlice.reducer